import { apiClient } from '@services/api-client'

import {
  settlementsUrl,
  useSettlementMutation
} from './useSettlementMutation'
import type { SettlementCreate, SettlementDetail } from '../types'

export function useCreateSettlement() {
  return useSettlementMutation<SettlementCreate, SettlementDetail>({
    toastKey: 'settlementCreated',
    request: async (body) =>
      (await apiClient.post<SettlementDetail>(settlementsUrl, body)).data
  })
}
